import React from 'react';

import PropTypes from 'prop-types';

function Building({ title, size = 16, color, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.88245 5.57049C2.88245 5.07957 3.27751 4.68159 3.7648 4.68159H20.706C21.1933 4.68159 21.5884 5.07956 21.5884 5.57049V13.5705H16.9413C16.129 13.5705 15.4706 14.2338 15.4706 15.052V27.3186H13.1766V22.6371H7.5295V27.3186H3.7648C3.27749 27.3186 2.88245 26.9206 2.88245 26.4297V5.57049ZM18.8236 29.3196V29.3334H3.7648C2.17295 29.3334 0.882446 28.0335 0.882446 26.4297V5.57049C0.882446 3.96682 2.17293 2.66678 3.7648 2.66678H20.706C22.2978 2.66678 23.5884 3.96683 23.5884 5.57049V13.5705H30.1177C30.9301 13.5705 31.5884 14.2338 31.5884 15.052V27.8382C31.5884 28.6563 30.93 29.3196 30.1177 29.3196H18.8236ZM20.706 18.8446V22.6371H22.5884V18.8446H20.706ZM24.4706 22.6371V18.8446H26.353V22.6371H24.4706ZM17.4706 27.3048V15.5853H29.5884V27.3048H17.4706ZM5.64716 7.46678H7.5295V11.2594H5.64716V7.46678ZM7.5295 15.052H5.64716V18.8446H7.5295V15.052ZM11.2942 7.46678H13.1766V11.2594H11.2942V7.46678ZM13.1766 15.052H11.2942V18.8446H13.1766V15.052ZM16.9413 7.46678H18.8236V11.2594H16.9413V7.46678Z"
        fill={color}
      />
    </svg>
  );
}
Building.propTypes = {
  title: PropTypes.string,
  size: PropTypes.number,
  color: PropTypes.string,
};

export default Building;
